var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3 p-3"},[_c('h3',{staticClass:"pb-3"},[_vm._v("拠点管理")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }